export default __webpack_public_path__ + "static/media/borku-AppleStore.51e3383d.svg";